module.exports = __webpack_public_path__ + "img/bind-success-logo.1ac22fdc.png";